import type { ServerToClientMessage } from '../types';
import { useMetricsStore } from '../../stores/metricsStore';
import { useInfraStore } from '../../stores/infraStore';
import { useSentimentStore } from '../../stores/sentimentStore';
import { useBulkStatusStore } from '../../stores/bulkStatusStore';

export function dispatchSentimentMessage(msg: ServerToClientMessage): boolean {
  switch (msg.type) {
    case 'sentiment-update':
      useSentimentStore.getState().addEvent(msg.event);
      return true;
    case 'sentiment-snapshot':
      useSentimentStore.getState().setEvents(msg.events);
      if (msg.calendar) {
        useSentimentStore.getState().setCalendar(msg.calendar);
      }
      return true;
    case 'sentiment-factor-update':
      useSentimentStore.getState().setFactor(msg.factor);
      return true;
    case 'sentiment-factor-snapshot':
      useSentimentStore.getState().setFactors(msg.factors);
      return true;
    case 'service-metrics-update':
    case 'service-metrics-snapshot':
      useMetricsStore.getState().setServices(msg.services);
      return true;
    case 'ingest-freshness-update':
    case 'ingest-freshness-snapshot':
      useMetricsStore.getState().setFreshness(msg.snapshot);
      return true;
    case 'infra-status-update':
    case 'infra-status-snapshot':
      useInfraStore.getState().setServices(msg.services);
      return true;
    case 'bulk-status-update':
    case 'bulk-status-snapshot':
      useBulkStatusStore.getState().setStatus(msg.status);
      return true;
    default:
      return false;
  }
}
